<template>
    <div class="bg-base p-34 text-16 h-full overflow-y-auto relative" >
        <div class="instructions-container w-full pr-6 flex flex-col gap-16" v-if="currentPOI">
            <div class="bg-secondary rounded-lg w-12 h-12"></div>
            <ul v-if="instructions && instructions.steps" class="list-disc pl-20 flex flex-col gap-8 list-image-none">
                <li v-for="(step, index) in instructions.steps" :key="index" class="flex items-start gap-12">
                    <WFIcon class="w-16 h-20" :name="stepIcon(step)"></WFIcon>
                    
                    <div class="flex flex-col gap-2">
                        <div><WFTranslate :k="stepTranslate(step)" :params="stepParams(step)"></WFTranslate></div>
                    </div>
                </li>
            </ul>
            <div class="flex gap-12 items-center" >
                <WFIcon class="w-12 h-14" name="step-destination"></WFIcon>
                <label>{{ currentPOI.getName(language) }}</label>
            </div>
        </div>
        <div class="qr flex flex-col items-center gap-4 p-8 text-12 border th-border absolute bottom-32" v-if="qr">
            <WFTranslate k="offer-qr"></WFTranslate>
            <img :src="qr" class="w-80"/>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import QRCode from 'qrcode';

export default {
    props: ['poi'],
    computed: {
        ...mapState('wf', ["language"]),
        ...mapState(["currentPOI"]),
    },
    data() {
        return {
            instructions: [],
            qr: null,
        }
    },
    watch: {
        currentPOI () {
            this.updateInstructions();
        }
    },
    mounted () {
      this.updateInstructions();  
    },
    methods: {
        updateInstructions() {
            if(this.currentPOI && this.$wayfinder) {
                let path = this.$wayfinder.findPath(this.$wayfinder.getKioskNode(), this.currentPOI.getNode());
                
                if(path && path.length > 1) {
                    let _instructions = this.$wayfinder.pathToText(path);
                    
                    if( !_instructions || !_instructions.steps || _instructions.steps.length > 0) {
                        _instructions.steps = _instructions.steps.map(step => {
                            step.endNode = Object.freeze(step.endNode);
                            step.startNode = Object.freeze(step.startNode);
                            return step;
                        })
                        this.instructions = Object.freeze(_instructions);
                        let url = this.$wayfinder.translator.get("web_wayfinder_page", "");
                        if (url && url != "web_wayfinder_page") {
                            this.genQR(url, this.currentPOI);
                        }
                        
                    }
                    else {
                        this.instructions = [];
                    }
                } else {
                    this.instructions = [];
                }
            } else {
                this.instructions = [];
            }
        },
        stepType(step) {
            switch(step.type) {
                case "turn":
                    return "turn-" + step.turn;
                case "walk":
                     return "walk";
                case "use":
                     return "use-" + step.use;
                case "go_to_floor":
                     return "go-to-floor";
                default:
                    return "step";
            }
        },
        stepIcon(step) {
            return "step-" + this.stepType(step);
        },
        stepTranslate(step) {
            return "path-"+ this.stepType(step);
        },
        stepParams (step) {
            //console.log(step);
            switch(step.type) {
                case "walk":
                    return [Math.round(step.walk)]
                case "go_to_floor":
                    return [step.endNode.floor.getName(this.language)]
                case "use":
                    return []
                default:
                    return [];
            }
        },
        genQR (url, _poi) {
            console.log('genQR', url, _poi)
            if(_poi) {
                let kiosk = this.$wayfinder.getKiosk();
                let slug = _poi.getAttributeString("slug");
                url += "?kiosk=" +kiosk+ "&destination=" + slug;
                console.log('url', url)
                QRCode.toDataURL(url).then((val) => {
                    this.qr = val;
                })
            }
        }
    }
}
</script>

<style scoped>
.instructions-container {
    border-left: 0.2rem solid var(--th-border);
    
    & > * {
        margin-left: -0.64rem;
    }
}
</style>